/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export class AlfrescoApiConfig {
    constructor(input = { oauth2: {} }) {
        this.hostEcm = 'http://127.0.0.1:8080';
        this.hostBpm = 'http://127.0.0.1:9999';
        this.authType = 'BASIC';
        this.contextRoot = 'alfresco';
        this.tenant = '-default-';
        this.contextRootBpm = 'activiti-app';
        this.domainPrefix = '';
        this.provider = 'ECM';
        this.disableCsrf = false;
        this.withCredentials = false;
        this.oauthInit = true;
        Object.assign(this, input);
        this.hostEcm = input.hostEcm ? input.hostEcm : 'http://127.0.0.1:8080';
        this.hostBpm = input.hostBpm ? input.hostBpm : 'http://127.0.0.1:9999';
        this.authType = input.authType ? input.authType : 'BASIC';
        this.contextRoot = input.contextRoot ? input.contextRoot : 'alfresco';
        this.contextRootBpm = input.contextRootBpm ? input.contextRootBpm : 'activiti-app';
        this.tenant = input.tenant ? input.tenant : '-default-';
        this.provider = input.provider ? input.provider : 'ECM';
        this.disableCsrf = input.disableCsrf ? input.disableCsrf : false;
        this.domainPrefix = input.domainPrefix ? input.domainPrefix : '';
        this.withCredentials = input.withCredentials ? input.withCredentials : false;
        this.oauth2 = input.oauth2;
    }
}
